(ns entities.key-accomplishments.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::name string?)
(s/def ::notes string?)
(s/def ::date-completed string?) ;; @TODO, date

(s/def ::key-accomplishment (s/keys :req-un [::name
                                             ::notes
                                             ::date-completed]))

(s/def ::key-accomplishments (s/coll-of ::key-accomplishment))
